var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery0BarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17,5v16c0,.55-.45,1-1,1h-8c-.55,0-1-.45-1-1V5c0-.55.45-1,1-1h2v-2h4v2h2c.55,0,1,.45,1,1Zm-2,1h-6v14h6V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery0BarOutlined);
export default __webpack_public_path__ + "static/media/Battery0BarOutlined.6a0cf5d1374b6ff3dd1b424d812773a7.svg";
export { ForwardRef as ReactComponent };